import React from 'react';
import './styles.scss';
import { Modal } from 'antd';

const MyModal = (props) => {
  return (
    <Modal
      centered
      visible={props.visible}
      className={`my-modal ${props.classNameModal}`}
      width={'80%'}
      {...(props.footerNull ? { footer: null } : {})}
      destroyOnClose
      onCancel={props.onClose}
      maskClosable={false}
      keyboard={false}
      okButtonProps={{
        className: 'ant-btn site-button btn-primary-custom w-175 h-45',
      }}
      cancelButtonProps={{
        className:
          'ant-btn site-button btn-secondary-outline primary-color w-175 h-45',
      }}
      {...props}
    >
      <div className="my-modal-wrapper">
        <div className="my-modal-body">{props.children}</div>
      </div>
    </Modal>
  );
};

export default MyModal;
